module.exports = __webpack_public_path__ + "img/user-octagon.ec05806d.svg";